import React, { useState } from 'react'
// @mui material components
import Card from "@mui/material/Card";
import { useNavigate } from 'react-router-dom';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";

import Swal from 'sweetalert2';
import AppPrioTable from './AppPrioTable';

import SearchStringOrIntReq from '../../../Classes/Models/Requests/SearchStringOrIntReq';
import SessionsApi from '../../../Classes/API/Administration/SessionsApi';
import ConfirmedAppointment from './ConfirmedAppointment';

const AppHourDetailsCard = ({ AppHour }) => {
  let navigate = useNavigate();

  const GoToAccSessionDetails = (AccSession) => {
    navigate(
      '/AccountingSessions/Details',
      {
        state: {
          SearchSession: AccSession,
        }
      }
    )
  }
  const CreateAppointment = () => {
    navigate(
      '/Appointments/CreateAppointment',
      {
        state: {
          AppHour: AppHour,
        }
      }
    )

  }

  const ToggleSessionAdmission = async (AccSession) => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = AccSession.id;

    let res = await SessionsApi.ToggleAccountingSessionAdmission(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");

      window.location.reload();
    }
    else {
      Swal.fire("Failed", res.message, "error");
    }
  }

  const getConfirmedAppointments = () => {
    if (AppHour.getConfirmedAppointment) {
      return (
        <ConfirmedAppointment Appointment={AppHour.getConfirmedAppointment} />
        )
      }
      if (AppHour.getFirstConfirmedAppointment && !AppHour.getSecondConfirmedAppointment) {
      console.log("has confirmed appointment", AppHour);
      return (
        <>
          <ConfirmedAppointment Appointment={AppHour.getFirstConfirmedAppointment} />

          <span class="badge badge-danger">NO CONFIRMED SECOND APPOINTMENTS</span>
        </>
      )
    }
    if (!AppHour.getFirstConfirmedAppointment && AppHour.getSecondConfirmedAppointment) {
      return (
        <>
          <span class="badge badge-danger">NO CONFIRMED FIRST APPOINTMENT</span>

          <ConfirmedAppointment Appointment={AppHour.getSecondConfirmedAppointment} />

        </>
      )
    }
    if (AppHour.getFirstConfirmedAppointment && AppHour.getSecondConfirmedAppointment) {
      return (
        <>
          <span class="badge badge-primary">1st</span>

          <ConfirmedAppointment Appointment={AppHour.getFirstConfirmedAppointment} />
          <span class="badge badge-secondary">2nd</span>
    
          <ConfirmedAppointment Appointment={AppHour.getSecondConfirmedAppointment} />
        </>
      )
    }
  }
  if (Object.keys(AppHour).length < 1) {
    return (
      <div>
        LOADING...
      </div>
    )
  }
  return (

    <div className="card">


      <MDBox display="flex" py={1} pr={2}>
        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
          Appointment Hour Id: &nbsp;
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" color="text">
          &nbsp;
          {AppHour.id}
        </MDTypography>
      </MDBox>

      <MDBox display="flex" py={1} pr={2}>

        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
          Therapist: &nbsp;
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" color="text">
          &nbsp;
          {AppHour.getAppointmentDayTherapist &&
            AppHour.getAppointmentDayTherapist.getTherapist.getUser.name}
        </MDTypography>
      </MDBox>


      <MDBox display="flex" py={1} pr={2}>

        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
          Time: &nbsp;
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" color="text">
          &nbsp;
          {AppHour.appointmentHourTime}
        </MDTypography>
      </MDBox>

      <MDBox display="flex" py={1} pr={2}>

 
        <MDTypography variant="button" fontWeight="regular" color="text">
          &nbsp;
          {AppHour.hasConfirmedAppointment ? getConfirmedAppointments():
            <span class="badge badge-danger">NO CONFIRMED APPOINTMENTS</span>
          }
        </MDTypography>
      </MDBox>


      <MDBox py={1} pr={2}>

        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
          Appointment List: {AppHour.getAppointments.length} Appointments <button onClick={() => CreateAppointment()} className='btn btn-outline-dark'>Create Appointment</button>
        </MDTypography>

        <AppPrioTable Apps={AppHour.getAppointments} AppHour={AppHour} />

      </MDBox>


    </div>

  )
}

export default AppHourDetailsCard